import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth/auth.service';
import { LocalizationService } from '../core/localization/localization.service';

@Component({
  standalone: true,
  selector: 'ain-login',
  imports: [FormsModule],
  template: `
    <form class="login-shell" (ngSubmit)="submit()">
      <h1>{{ t('login.adminTitle') }}</h1>
      <label>
        {{ t('login.email') }}
        <input name="email" type="email" [(ngModel)]="email" autocomplete="username" required>
      </label>
      <label>
        {{ t('login.password') }}
        <input name="password" type="password" [(ngModel)]="password" autocomplete="current-password" required>
      </label>
      @if (error()) {
        <p class="error">{{ error() }}</p>
      }
      <button type="submit" [disabled]="submitting()">{{ t('login.submit') }}</button>
    </form>
  `,
  styles: [`
    .login-shell {
      display: grid;
      gap: 16px;
      max-width: 420px;
      margin: 80px auto;
      background: white;
      border-radius: 16px;
      padding: 32px;
    }
    label { display: grid; gap: 6px; }
    input { border: 1px solid #d1d5db; border-radius: 10px; padding: 10px 12px; }
    button { border: 0; border-radius: 10px; padding: 12px; color: white; background: var(--ain-color-primary); }
    .error { color: #b91c1c; }
  `]
})
export class LoginComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly localizationService = inject(LocalizationService);

  email = '';
  password = '';
  readonly submitting = signal(false);
  readonly error = signal<string | null>(null);
  private returnUrl = '/dashboard';

  ngOnInit(): void {
    this.localizationService.loadResources().subscribe();
    const requested = this.route.snapshot.queryParamMap.get('returnUrl');
    if (requested?.startsWith('/')) {
      this.returnUrl = requested;
    }
  }

  submit(): void {
    this.submitting.set(true);
    this.error.set(null);
    this.authService.login({ email: this.email, password: this.password }).subscribe({
      next: () => void this.router.navigateByUrl(this.returnUrl),
      error: () => {
        this.error.set(this.t('login.invalidCredentials'));
        this.submitting.set(false);
      }
    });
  }

  t(key: string): string {
    return this.localizationService.translate(key);
  }
}
